import config from '../config';

/**
 * Fetch all user preferences from the API
 * @param {string} token - Auth token
 * @returns {Promise<Object>} - Object mapping keys to values { key: value, ... }
 */
export const fetchPreferences = async (token) => {
  const url = `${config.apiUrl}/user_preferences/`;
  const res = await fetch(url, {
    headers: {
      'Accept': 'application/json',
      'Authorization': `Token ${token}`,
    },
  });
  if (!res.ok) throw new Error(`Failed to fetch preferences: ${res.status}`);
  const data = await res.json();

  // Convert list of {id, key, value} records to {key: value} map
  const prefs = {};
  (data.results || []).forEach(record => {
    prefs[record.key] = record.value;
  });
  return prefs;
};

/**
 * Upsert multiple preferences
 * @param {string} token - Auth token
 * @param {number|string} userId - User ID
 * @param {Object} updates - Object of { key: value } pairs to upsert
 * @returns {Promise<Object>} - API response
 */
export const updatePreferences = async (token, userId, updates) => {
  const url = `${config.apiUrl}/user_preferences/${userId}/`;
  const res = await fetch(url, {
    method: 'PUT',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`,
    },
    body: JSON.stringify(updates),
  });
  if (!res.ok) throw new Error(`Failed to update preferences: ${res.status}`);
  return res.json();
};

/**
 * Delete preference keys
 * @param {string} token - Auth token
 * @param {number|string} userId - User ID
 * @param {string[]} keys - Array of keys to delete
 * @returns {Promise<Object|null>} - API response or null for 204
 */
export const deletePreferenceKeys = async (token, userId, keys) => {
  const url = `${config.apiUrl}/user_preferences/${userId}/`;
  const res = await fetch(url, {
    method: 'DELETE',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`,
    },
    body: JSON.stringify({ keys }),
  });
  if (!res.ok) throw new Error(`Failed to delete preferences: ${res.status}`);
  if (res.status === 204) return null;
  return res.json();
};
